import styled from 'styled-components';

export const Centered = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
`;
